import 'antd/dist/antd.less';
import React from 'react';

import {Amplify} from 'aws-amplify';
import {createRoot} from 'react-dom/client';

import Root from './Root';

import {config} from 'stage.config';

import './global.config';

// Configure Amplify v6
Amplify.configure({
  Auth: {
    Cognito: {
      identityPoolId: config.identityPoolId,
      userPoolId: config.userPoolId,
      userPoolClientId: config.userPoolWebClientId,
      allowGuestAccess: false
    }
  },
  Storage: {
    S3: {
      bucket: config.serviceBucket,
      region: config.region,
      buckets: {
        [config.serviceBucket]: {
          bucketName: config.serviceBucket,
          region: config.region
        },
        [config.adminBucket]: {
          bucketName: config.adminBucket,
          region: config.region
        }
      }
    }
  }
});

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
if (import.meta.env.DEV) {
  import('react-grab').then(() => import('@react-grab/mcp/client'));
}
